import React from 'react';
import { connect } from 'react-redux';

import FormCredenciamento from '../../../../containers/forms/credenciamento/FormCredenciamento';

class Cadastro extends React.Component {
    render(){
        return (
            <FormCredenciamento 
            dadosevento={
                {
                idevento: 7,
                idpromotora: 68,
                categoria: 'E',
                lingua: 'PT'
                }               
            }
            dadoscadastro={
                {
                    idfisica: 325655
                }
            }
            btosair={
                {
                url: '',
                texto: 'SAIR'
                }
            }
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        getCredencial: state.getCredencialReducer
    }
}

export default connect(mapStateToProps)(Cadastro);